type CampaignOverviewListParams = {
  integrationName: string;
  clientId: string;
  search?: string;
  statusFilter?: string;
  page?: number;
  pageSize?: number;
};

export const campaignIntegrationQueryKeys = {
  all: ["integrations"] as const,
  byIntegration: (integrationName: string) =>
    [...campaignIntegrationQueryKeys.all, integrationName.toLowerCase()] as const,
  byModule: (integrationName: string) =>
    [...campaignIntegrationQueryKeys.byIntegration(integrationName), "campaigns"] as const,
  overview: (integrationName: string, clientId: string) =>
    [...campaignIntegrationQueryKeys.byModule(integrationName), "overview", clientId] as const,
  overviewList: (params: CampaignOverviewListParams) =>
    [
      ...campaignIntegrationQueryKeys.overview(params.integrationName, params.clientId),
      {
        search: params.search,
        statusFilter: params.statusFilter,
        page: params.page,
        pageSize: params.pageSize,
      },
    ] as const,
  overviewInfinite: (
    params: Omit<CampaignOverviewListParams, "page" | "pageSize">
  ) =>
    [
      ...campaignIntegrationQueryKeys.overview(params.integrationName, params.clientId),
      "infinite",
      { search: params.search, statusFilter: params.statusFilter },
    ] as const,
};
